/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Intro_Stat_2_DescInputs */

const tr_landing_intro_stat_2_desc = /** @type {(inputs: Landing_Intro_Stat_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masaüstü panelde 7/24 yanıt verir; ekibimiz hafta içi 09:00 ile 18:00 (TSİ) arası yanınızda, ek ücret yok.`)
};

const en_landing_intro_stat_2_desc = /** @type {(inputs: Landing_Intro_Stat_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answers 24/7 in the panel on desktop; our team is there for you on weekdays from 09:00 to 18:00 (Turkey time), at no extra cost.`)
};

const de_landing_intro_stat_2_desc = /** @type {(inputs: Landing_Intro_Stat_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antwortet rund um die Uhr im Panel am Desktop; unser Team ist montags bis freitags von 09:00 bis 18:00 Uhr (türkische Zeit) für Sie da, ohne Zusatzkosten.`)
};

const ru_landing_intro_stat_2_desc = /** @type {(inputs: Landing_Intro_Stat_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отвечает 24/7 в панели на компьютере; команда на связи в будни с 09:00 до 18:00 (по времени Турции), без доплаты.`)
};

/**
* | output |
* | --- |
* | "Answers 24/7 in the panel on desktop; our team is there for you on weekdays from 09:00 to 18:00 (Turkey time), at no extra cost." |
*
* @param {Landing_Intro_Stat_2_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_intro_stat_2_desc = /** @type {((inputs?: Landing_Intro_Stat_2_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Intro_Stat_2_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_intro_stat_2_desc(inputs)
	if (locale === "de") return de_landing_intro_stat_2_desc(inputs)
	if (locale === "ru") return ru_landing_intro_stat_2_desc(inputs)
	return tr_landing_intro_stat_2_desc(inputs)
});